import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ClientService } from "src/app/features/services";
import { BTNS_INVERTIR, URL_INGRESO_ORDENES_FWD } from "src/app/shared/constants/landing-investments.constants";
import { AppService, ExecutiveService } from "src/app/shared/services";

@Component({
    selector: 'app-landing-investments',
    templateUrl: './landing-investments.component.html',
    styleUrls: ['./landing-investments.component.scss'],
    providers: [],
})
export class LandingInvestmentsComponent implements OnInit {

    btnsInvertir = [];
    rutCliente;
    mainPath;

    constructor(
        private clientService: ClientService,
        private activateRoute: ActivatedRoute,
        private executive: ExecutiveService,
        private appService: AppService,
        private router: Router
    ) {

    }

    get puedeVisualizarCliente(){
        return sessionStorage.getItem("puedeVisualizarCliente") === "true";
    }

    ngOnInit(): void {
        this.activateRoute.params.subscribe(param => {

            this.rutCliente = param.rut ?? null;
            this.mainPath = '/main/client-search/summary/' + this.rutCliente;
            const puedeTransaccionar = this.executive.getPerfil()?.executiveProfile?.allowTransaction;

            if(!puedeTransaccionar){
                this.appService.alertaMensaje("Entendido", "Importante",`Usted no tiene permisos para Transaccionar.`);
                this.router.navigate([this.mainPath]);
            }

            this.btnsInvertir = BTNS_INVERTIR.map(item => {
                switch (item.id) {
                    case 'pershing-selector-cuenta':
                        try {
                            const productos = JSON.parse(sessionStorage.getItem("clienteBalances") ?? "[]");
                            const tienePershing = productos.some(item => item.codigoCb?.indexOf("PERSHING") >= 0);
                            item.activo = tienePershing && this.puedeVisualizarCliente;
                        } catch (err) {
                            console.log(err);
                        }
                        break;
                    case 'ingreso-ordenes-bolsa':
                    case 'ingreso-ordenes-divisas':
                        item.activo = item.activo && this.puedeVisualizarCliente;
                        break;
                    case 'invertir-apv':
                        item.activo = sessionStorage.getItem("tipoPer") !== 'J';
                        break;
                    case 'forward':
                        item.activo = JSON.parse(sessionStorage.getItem("tieneContratoFw")) ?? false;
                        break;
                }
                return item;
            })
        });
    }

    get clientData() {
        try {
            return JSON.parse(sessionStorage.getItem("clientData"));
        } catch (err) {
            return null;
        }
    }

    volverAResumen() {
        this.router.navigate([this.mainPath], { queryParams: { from: 'wfi' } });
    }

    goTo(id: string) {

        const clientInfo = JSON.parse(sessionStorage.getItem("dataClient"));
        const origen = this.router.url;
        const cliente = {
            rut: `${clientInfo.RutCliente}-${clientInfo.DigitoVerificador}`,
            nombre: clientInfo.NombreCliente,
            apellidoPaterno: clientInfo.NombreCliente.split(' ')[0],
            apellidoMaterno: clientInfo.NombreCliente.split(' ')[1],
        }

        switch (id) {
            case 'invertir-no-apv':
                this.clientService.irAWFI(cliente, 'noapv', origen);
                break;
            case 'invertir-apv':
                this.clientService.irAWFI(cliente, 'apv', origen);
                break;
            case 'ingreso-ordenes-bolsa':
                this.router.navigate([this.mainPath + '/corredora-orden-compra-venta']);
                break;
            case 'ingreso-ordenes-divisas':
                this.router.navigate([this.mainPath + '/divisas-orden-compra-venta']);
                break;
            case 'pershing-selector-cuenta':
                this.router.navigate([this.mainPath + '/pershing-selector-cuenta']);
                break;
            case 'forward':
                window.open(URL_INGRESO_ORDENES_FWD, '_blank');
                break;
        }
    }

}
